/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import './device_code';
import '../internal/message/send_device_code_password';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "external": {
            "nested": {
              "CreateDeviceCodeRequest": {
                "fields": {
                  "idempotencyKey": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "deviceCode": {
                    "type": ".squareup.devicesettings.external.DeviceCode",
                    "id": 2,
                    "rule": "optional"
                  },
                  "sendPasswordRequest": {
                    "type": ".squareup.devicesettings.internal.message.SendDeviceCodePasswordRequest",
                    "id": 3,
                    "rule": "optional"
                  },
                  "isInternal": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "CreateDeviceCodeResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "deviceCode": {
                    "type": ".squareup.devicesettings.external.DeviceCode",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.external?.nested?.CreateDeviceCodeRequest && !$root.nested?.squareup?.nested?.devicesettings?.nested?.external?.nested?.CreateDeviceCodeResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CreateDeviceCodeRequest @ squareup/devicesettings/external/device_code_create.proto at 16:1
 */
export const CreateDeviceCodeRequest = $root.lookupType('squareup.devicesettings.external.CreateDeviceCodeRequest');
fixType(CreateDeviceCodeRequest, {
  idempotencyKey: {
    notEmpty: true
  },
  deviceCode: {
    required: true
  }
});
Builder.createAndAttachToType(CreateDeviceCodeRequest);
/**
 * SOURCE CreateDeviceCodeResponse @ squareup/devicesettings/external/device_code_create.proto at 45:1
 */
export const CreateDeviceCodeResponse = $root.lookupType('squareup.devicesettings.external.CreateDeviceCodeResponse');
fixType(CreateDeviceCodeResponse);
Builder.createAndAttachToType(CreateDeviceCodeResponse);